/** @format */

import { clientAddressesConstants } from './actions';
import { reducerDebug } from '../../../core/debug';

export function clientAddressesReducers(state = {}, action) {
    reducerDebug('Client Addresses reducer: ' + action.type);
    switch (action.type) {
        case clientAddressesConstants.CLIENT_ADDRESS_LIST:
            return {
                type: action.type,
                addressCollections: action.collections,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_ITEM:
            return {
                type: action.type,
                addressItem: action.item,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_EDIT:
        case clientAddressesConstants.CLIENT_ADDRESS_UPDATE:
        case clientAddressesConstants.CLIENT_ADDRESS_ADD:
            return {
                type: action.type,
                success: true,
                addressData: action.data,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_DELETE:
            return {
                type: action.type,
                deletedSuccess: true,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_STREET_CHECK:
            return {
                ...state,
                type: action.type,
                streets: action.collections,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_CITY_CHECK:
            return {
                ...state,
                type: action.type,
                cities: action.collections,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_BOROUGH_CHECK:
            return {
                ...state,
                type: action.type,
                boroughs: action.collections,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_DISTRICT_CHECK:
            return {
                ...state,
                type: action.type,
                districts: action.collections,
            };
        case clientAddressesConstants.CLIENT_ADDRESS_STATE_CHECK:
            return {
                ...state,
                type: action.type,
                states: action.collections,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
                reloadItem: false,
                type: action.type,
            };
    }
}
